import PropTypes from 'prop-types';

import { InsightBox } from '../InsightBox';

import { KeywordsGroup } from './components/KeywordsGroup';
import { useStyles } from './useStyles';

export const SEOTracker = ({
  markedKeywordsMap,
  targetKeywords,
  supportingKeywords,
  onToggleMarkedKeyword,
  onExpand,
}) => {
  const styles = useStyles();

  return (
    <InsightBox
      title="SEO keyword tracker"
      subtitle={`${targetKeywords.length} primary keywords • ${supportingKeywords.length} secondary keywords`}
      onExpand={onExpand}
      collapsableContent={
        (targetKeywords.length > 0 || supportingKeywords.length > 0) && (
          <div className={styles.keywordsGroups}>
            <KeywordsGroup
              classes={{ counter: styles.targetCounter }}
              title="Primary Keywords"
              keywords={targetKeywords}
              onToggleMarkedKeyword={onToggleMarkedKeyword}
              markedKeywordsMap={markedKeywordsMap}
            />
            <KeywordsGroup
              classes={{ counter: styles.relatedCounter }}
              title="Secondary Keywords"
              keywords={supportingKeywords}
              onToggleMarkedKeyword={onToggleMarkedKeyword}
              markedKeywordsMap={markedKeywordsMap}
            />
          </div>
        )
      }
    />
  );
};

SEOTracker.propTypes = {
  markedKeywordsMap: PropTypes.objectOf(PropTypes.bool),
  targetKeywords: PropTypes.arrayOf(PropTypes.shape({})),
  supportingKeywords: PropTypes.arrayOf(PropTypes.shape({})),
  onToggleMarkedKeyword: PropTypes.func,
  onExpand: PropTypes.func,
};

SEOTracker.defaultProps = {
  markedKeywordsMap: {},
  targetKeywords: [],
  supportingKeywords: [],
  onToggleMarkedKeyword: null,
  onExpand: null,
};
